<template>
  <div>
    <Create
      :create="createItem"
      :close="closeCreate"
      :menusOption="menusOption"
    ></Create>
    <Edit
      :item="currentItem"
      :update="updateItem"
      :close="closeEdit"
      :menusOption="menusOption"
    ></Edit>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 28 28"
              style="enable-background: new 0 0 28 28"
              xml:space="preserve"
            >
              <path
                d="M15,18v-4h-4v8l4,0.001V20h8v8h-8v-4H9V8H5V0h8v8h-2v4h4v-2h8v8H15z"
              ></path>
            </svg>
            Categorias
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/">Dados</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <form class="form-single" v-on:submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for>Título</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.titulo"
                      />
                      <div class="message">
                        {{ validation.firstError("item.titulo") }}
                      </div>
                      <br />
                      <button class="button button-success">Alterar</button>
                    </div>
                  </div>
                  <!-- <div class="col-1-2">
                    <div class="form-group">
                      <label for>Subtitulo</label>
                      <input type="text" class="form-control" v-model="item.subTitulo">
                      <div class="message">{{ validation.firstError('item.subTitulo') }}</div>
                    </div>
                  </div>-->
                </div>
              </form>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      Tam:
                      <span class="label primary">100 x 100</span>
                    </th>
                    <th>Visível</th>
                    <th>Ordem</th>
                    <th>ID ERP</th>
                    <th>Título</th>
                    <th>
                      <!-- <button
                        class="button button-success button-sm button-block"
                        v-on:click="openCreate()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          ></path>
                        </svg>
                        NovoNovo
                      </button>-->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(i, index) in item.categorias"
                    v-bind:key="index"
                    v-bind:class="{
                      'bg-error': !i.visivel || (i.visivel && !i.img),
                    }"
                  >
                    <td style="position: relative">
                      <!-- <small
                        class="td-error-message text-error"
                        v-if="i.visivel && !i.img"
                      >Categorias sem um ícone não serão mostradas no site.</small>-->
                      <div class="imgbox" v-if="!!i.img">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(index)"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                ></path>
                              </g>
                            </svg>
                          </button>
                          <img :src="getImage(i.img)" />
                        </span>
                      </div>
                      <div
                        class="imgbox"
                        v-bind:class="{ error: i.visivel && !i.img }"
                        v-else
                      >
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                ></path>
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="handleUpload(index)"
                            />
                          </label>
                        </span>
                      </div>
                    </td>
                    <td>
                      <span v-if="i.visivel" class="label success">Sim</span>
                      <span v-else class="label error">Não</span>
                    </td>
                    <td>
                      <span class="label primary">{{ i.ordem }}</span>
                    </td>
                    <td class="highlight">{{ i.idErp }}</td>
                    <td class="highlight">{{ i.titulo }}</td>

                    <td class="actions">
                      <a
                        class="button button-primary"
                        v-on:click="openEdit(index)"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            ></path>
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <!-- <button
                        class="button button-error"
                        v-on:click="deleteItem(index)"
                      >
                        <svg
                          style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            ></path>
                          </g>
                      </svg>-->
                      <!-- </button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "simple-vue-validator";
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
import Create from "./Create";
import Edit from "./Edit";

const url = "/categorias";

export default {
  name: "config",
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      loading: false,
      item: {
        _id: "",
        titulo: "",
        // subTitulo: "",
        categorias: [],
      },
      currentItem: {
        _id: 0,
        titulo: "",
        link: "",
        ordem: "",
        idErp: "",
        img: "",
        visivel: false,
      },
      menusOption: [],
    };
  },
  validators: {
    "item.titulo": (value) => Validator.value(value).required(),
    // "item.subTitulo": value => Validator.value(value).required()
  },
  methods: {
    getImage: getImage,
    fetchCategorias() {
      get(url)
        .then((json) => {
          this.loading = false;
          this.item = {
            _id: json._id,
            titulo: json.titulo || "Categorias",
            // subtitulo: json.subtitulo,
            categorias: json.categorias,
          };
          this.menusOption = json.menus;
        })
        .catch((err) => alert(err.message));
    },
    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.save()
            .then((json) => {
              this.$swal({
                title: "Dados Alterados com Sucesso!",
                type: "success",
              });
            })
            .catch((err) => {
              this.$swal({
                title: "Houve um erro",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    save() {
      this.item.categorias.sort((current, next) => +current.ordem - next.ordem);
      return put(`${url}/${this.item._id}`, this.item);
    },
    deleteItem(index) {
      const { _id } = this.item;
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(`${url}/${_id}/${index}`).then((json) => {
            this.item.categorias = this.item.categorias.filter(
              (_, k) => +index !== +k
            );
            this.loading = false;
          });
        },
        () => {}
      );
    },
    openCreate() {
      this.$modal.show("categoriaCreate");
    },
    closeCreate() {
      this.$modal.hide("categoriaCreate");
    },
    createItem(titulo, link, ordem, idErp) {
      this.loading = true;
      this.item.categorias.push({
        titulo,
        link,
        ordem,
        idErp,
        img: "",
      });

      this.save()
        .then((json) => {
          this.loading = false;
          this.$swal({ title: "Criado com Sucesso!", type: "success" });
        })
        .catch((err) => {
          this.$swal({
            title: "Houve um erro! :(",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openEdit(index) {
      const { titulo, ordem, link, idErp, img, visivel } =
        this.item.categorias[index];
      this.loading = false;
      this.currentItem = Object.assign(
        {},
        {
          index,
          titulo,
          link,
          ordem,
          idErp,
          img,
          visivel,
        }
      );
      this.$modal.show("categoriaEdit");
    },
    closeEdit() {
      this.currentItem = {
        titulo: "",
        link: "",
        ordem: "",
        idErp: "",
        img: "",
        visivel: false,
      };
      this.loading = false;
      this.$modal.hide("categoriaEdit");
    },
    updateItem() {
      this.loading = true;
      const { index, titulo, ordem, link, idErp, img, visivel } =
        this.currentItem;
      this.item.categorias = this.item.categorias.map((i, k) => {
        if (+index === +k) {
          return { titulo, ordem, link, idErp, img, visivel };
        }
        return i;
      });

      this.save()
        .then((json) => {
          this.loading = false;
          this.$swal({ title: "Alterado com Sucesso!", type: "success" });
        })
        .catch((err) => {
          this.$swal({
            title: "Houve um erro! :(",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          this.closeEdit();
        });
    },
    handleUpload(index) {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/nested/categorias/categorias/img/${this.item._id}/${index}`,
        dim: "100x100",
      };

      this.loading = true;
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.categorias = this.item.categorias.map((i, k) => {
            if (+index === +k) {
              i.img = filename;
            }
            return i;
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
    deleteImg(index) {
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(
            `/upload/nested/categorias/categorias/img/${this.item._id}/${index}`
          )
            .then((json) => {
              this.item.categorias = this.item.categorias.map((i, k) => {
                if (+index === +k) {
                  i.img = "";
                }
                return i;
              });
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        },
        () => {}
      );
    },
  },
  beforeMount() {
    this.loading = true;
    this.fetchCategorias();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Categorias/Categorias.vue